export default __webpack_public_path__ + "static/portfolio-cover-5-a5a3a3677459695549dcc2bc65d600ab.jpg";